import React from "react";

const Tracker = () => {
  return (
    <>
      <div className="card mt-3 border-0 shadow-sm">
        <div className="card-body">No Data</div>
      </div>
    </>
  );
};

export default Tracker;
